import { Routable } from '@torqit/torq-tools-react';
import { TermsConditionsDetails } from './TermsConditionsDetails';

export const termsConditionRoutes: Routable[] = [
  {
    route: '/terms-conditions',
    content: <TermsConditionsDetails />,
  },
];
